export default {
  PAGE_TITLE: 'Usuários',
  SEARCH_LABEL: 'Nome',
  getQuestionMessageDeleteDialog: nome => `Deseja excluir o usuário ${nome}? Ao confirmar, o usuário será excluído permanentemente`,
  FILIAL: 'Filial',
  TIPO_USUARIO: 'Tipo Usuário',
  STATUS: 'Status',
};
